import { CardUIExtension, ICardUIExtensionContext } from 'tessa/ui/cards';
import { CdGeneralDocumentationClientHelper } from 'src/cdScripts/Helpers/Cards/CdGeneralDocumentationClientHelper';
import { CdRequestForMaterialsSharedHelper } from 'src/cdScripts/Helpers/Cards/CdRequestForMaterialsSharedHelper';
import { Guid } from 'tessa/platform';
import { CdCardTypes } from 'src/cdScripts/Helpers/CdCardTypes';

export class CdRequestForMaterialsTaskUIExtension extends CardUIExtension {
  public async saving(context: ICardUIExtensionContext) {
    if (context.model == null ||
        context.model.card == null) {
      return;
    }
    if (!Guid.equals(context.model.card.typeId, CdCardTypes.PkRequestForMaterialsTypeID)) {
      return;
    }
    let tasks = context.card.tasks;

    //пока убираем подписание для заявок на материалы 44075
    await CdGeneralDocumentationClientHelper.CheckFieldsAfterTaskComplete(context, tasks
      ,CdRequestForMaterialsSharedHelper.ApproverTaskStoreInfo.TaskStartProcessTypesList
      ,CdRequestForMaterialsSharedHelper.ApproverTaskStoreInfo.TaskStartProcessOptionsList
      ,CdRequestForMaterialsSharedHelper.CheckFileCategoryList
      //,undefined
      //,CdRequestForMaterialsSharedHelper.ApproverTaskStoreInfo.TaskSignTypesList
      );
  } 
}